import React, { FC } from "react";
import "./style.scss";
import SubmitPhoto from "../../../../../assets/verification/SubmitPhoto.svg";
import GoBack from "../../../../../assets/verification/BackWhite.svg";
import ModalButton from "widgets/auth/components/modal-btn";
import { useTranslation } from "react-i18next";
import { DocumentType } from "static/types";

type PropType = {
  onClose: any;
  image: any;
  onSubmit: any;
  isSubmit: boolean;
  type: DocumentType;
};

const SubmitPhotoModal: FC<PropType> = ({
  onClose,
  image,
  onSubmit,
  type,
  isSubmit,
}) => {
  const cameraBoxClass: Record<typeof type, string> = {
    [DocumentType.Passport]: "docPhoto",
    [DocumentType.IdCard]: "docPhotoShort",
    [DocumentType.IdCardBack]: "docPhotoShort",
    [DocumentType.ProofAddress]: "docPhoto",
    [DocumentType.Selfie]: "docPhoto",
    [DocumentType.UtilityBill]: "docPhoto",
    [DocumentType.Avatar]: "docPhoto",
  };

  const { t } = useTranslation("onboarding-auth");

  return (
    <div className="submitPhotoModal">
      <button className="goBack" onClick={onClose}>
        <img src={GoBack} alt="Go Back" />
      </button>

      <div className={cameraBoxClass[type]}>
        <img src={image ? URL.createObjectURL(image) : ""} alt="img" />
        <span>{t("ensureDetailsClear")}</span>
      </div>

      <ModalButton
        customClass="submit-photo-modal"
        disabled={isSubmit}
        onClick={onSubmit}
      >
        <img src={SubmitPhoto} alt="SubmitPhoto" />
        {t("submitPhoto")}
      </ModalButton>
      <span className="retake-photo" onClick={onClose}>
        {t("retakePhoto")}
      </span>
    </div>
  );
};

export default SubmitPhotoModal;
